function loadDeps() {
    sswRun(function() {
        let dependencies = [{
                key: "review.critical.js",
                type: "SCRIPT",
            },
            {
                key: "review.widget.critical.js",
                type: "SCRIPT",
            },
            {
                key: "lib.modal.js",
                type: "SCRIPT",
            },
            {
                key: "lib.gw-carousel.js",
                type: "SCRIPT",
            },
            {
                key: "lib.gw-masonry.js",
                type: "SCRIPT",
            },
            {
                key: "review.main.js",
                type: "SCRIPT",
            },
            {
                key: "review.widget.main.js",
                type: "SCRIPT",
            },
            {
                key: "instagram.slider.lib.js",
                type: "SCRIPT",
            },
            {
                key: "lib.photoswipe.js",
                type: "SCRIPT",
            },
            {
                key: "lib.modal.css",
                type: "STYLE",
            },
            {
                key: "review.critical.css",
                type: "STYLE",
            },
            {
                key: "review.main.css",
                type: "STYLE",
            },
            {
                key: "question.main.css",
                type: "STYLE",
            },
            {
                key: "instagram.gallery.css",
                type: "STYLE",
            },
        ];
        dependencies.map(function(dependency) {
            window.Ssw.gwAssetsManifestLoader.requireByKey(dependency.key, dependency.type);
        });
    });
}
var sswInt = setInterval(function() {
    if (ssw("#review-photos-uploadForm").length) {
        loadDeps();
        clearInterval(sswInt);
    }
}, 1000);